import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('organization')
  .extendHookCollectionsFactory('organizations')
  .factory()

export {
  Provider as OrganizationProvider,
  useStore as useOrganizationStore,
}
